import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Check, X } from 'lucide-react';
export function ForWhoSection() {
  return <Section className="bg-white" data-id="element-154">
      <div className="text-center max-w-3xl mx-auto mb-8" data-id="element-155">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2c4a2c] mb-3" data-id="element-156">
          Para quién es (y para quién no)
        </h2>
        <p className="text-lg text-[#5a5a5a]" data-id="element-157">
          Si esto encaja contigo, lo vas a usar. Si no, mejor que no lo compres.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-158">
        <div className="bg-[#2c4a2c]/5 rounded-2xl p-6 border border-[#2c4a2c]/10" data-id="element-159">
          <h3 className="text-lg font-bold text-[#2c4a2c] mb-4 flex items-center gap-2" data-id="element-160">
            <span className="bg-[#2c4a2c] text-white rounded-full p-1" data-id="element-161">
              <Check className="w-4 h-4" data-id="element-162" />
            </span>
            Para ti si:
          </h3>
          <ul className="space-y-3" data-id="element-163">
            {['Te baja la energía por la tarde casi a diario', 'Quieres comer mediterráneo sin complicarte', 'Quieres menos antojos y menos dependencia del café', 'Necesitas plantillas y decisiones simples'].map((item, i) => <li key={i} className="flex items-start gap-2 text-[#2c4a2c] text-sm" data-id="element-164">
                <Check className="w-4 h-4 text-[#2c4a2c] shrink-0 mt-0.5" data-id="element-165" />
                <span data-id="element-166">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-red-50 rounded-2xl p-6 border border-red-100" data-id="element-167">
          <h3 className="text-lg font-bold text-red-900 mb-4 flex items-center gap-2" data-id="element-168">
            <span className="bg-red-200 text-red-800 rounded-full p-1" data-id="element-169">
              <X className="w-4 h-4" data-id="element-170" />
            </span>
            No es para ti si:
          </h3>
          <ul className="space-y-3" data-id="element-171">
            {['Buscas una dieta estricta con reglas rígidas', 'Quieres "energía máxima" sin tocar tu plato', 'Esperas resultados idénticos sin probar 7–14 días'].map((item, i) => <li key={i} className="flex items-start gap-2 text-red-800 text-sm" data-id="element-172">
                <X className="w-4 h-4 text-red-400 shrink-0 mt-0.5" data-id="element-173" />
                <span data-id="element-174">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mt-8 text-center" data-id="element-175">
        <Button variant="secondary" data-id="element-176">Sí, encaja conmigo</Button>
        <p className="mt-2 text-sm text-[#5a5a5a]" data-id="element-177">
          Mejor una compra correcta que una compra impulsiva.
        </p>
      </div>
    </Section>;
}